module.exports = __webpack_public_path__ + "static/media/washington-frown.ce40ded2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/roosevelt/images/washington-frown.jpg
// module id = 65
// module chunks = 0